const {KitModule, registerModule} = window;

import Swiper from 'swiper';

import {testimonialsPresets} from '../../modules/testimonials/testimonials.presets.util.js';
import {builtinPresets} from './carousel.presets.util.js';
import {bindAutoplayClassToggle} from './carousel.util.js';

/**
 * @param {string} name
 */
function getPreset(name) {
    return testimonialsPresets[name] ||
        builtinPresets[name] ||
        builtinPresets['library-default'];
}

class Carousel extends KitModule {
    constructor($element) {
        super($element);

        const presetName = $element.dataset.preset || 'library-default';
        const preset = getPreset(presetName);
        const navMode = $element.dataset.navMode || 'inline-pagination';
        const syncActiveSlides =
            $element.dataset.syncActiveSlides === 'true';
        const settings = $element.dataset.settings ?
            JSON.parse($element.dataset.settings) :
            {};
        const autoplayDisabledClass =
            $element.dataset.autoplayDisabledClass || '';

        const buildResult = preset({
            $host: $element,
            $swiperEl: $element,
            settings,
            navMode,
            syncActiveSlides,
        });

        if (buildResult.skipSwiper) {
            buildResult.afterInit?.(null);
            return;
        }

        this.swiper = new Swiper(
            buildResult.swiperEl,
            buildResult.swiperOptions,
        );

        buildResult.afterInit?.(this.swiper);

        if (
            autoplayDisabledClass &&
            settings.autoplay &&
            this.swiper?.autoplay
        ) {
            const $root =
                $element.closest('[data-carousel-autoplay-root]') ||
                $element;
            bindAutoplayClassToggle($root, this.swiper, autoplayDisabledClass);
        }
    }
}

registerModule('Carousel', Carousel);
